/* START_MODULE_CONTRACT
 * PURPOSE: Декоративная сетка планирования для страницы входа — визуальная метафора таймлайна команды.
 * SCOPE: Статическая разметка ячеек недели с анимацией появления.
 * DEPENDS: нет
 * LINKS: M-FE-AUTH
 * ROLE: RUNTIME
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * LoginPlanningGrid - сетка 7×5 с подсветкой «занятых» слотов.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Сигнатурный элемент страницы входа: сетка расписания.
 * END_CHANGE_SUMMARY
 */

const WEEKDAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

/** Индексы ячеек (row * 7 + col), которые выглядят «запланированными». */
const FILLED_SLOTS = new Set([2, 9, 10, 16, 23, 24, 25, 31]);

/* START_METHOD_LoginPlanningGrid */
/* START_CONTRACT: LoginPlanningGrid
 * PURPOSE: Отрисовать декоративную сетку расписания с подписями дней недели.
 * INPUTS: { className?: string }.
 * OUTPUTS: { JSX.Element }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-AUTH
 * END_CONTRACT: LoginPlanningGrid
 */
export default function LoginPlanningGrid({ className = '' }) {
  const cells = Array.from({ length: 35 }, (_, index) => ({
    index,
    filled: FILLED_SLOTS.has(index),
  }));

  return (
    <div className={`auth-grid ${className}`.trim()} aria-hidden="true">
      <div className="auth-grid__weekdays">
        {WEEKDAYS.map((day) => (
          <span key={day} className="auth-grid__weekday">
            {day}
          </span>
        ))}
      </div>
      <div className="auth-grid__cells">
        {cells.map(({ index, filled }) => (
          <span
            key={index}
            className={`auth-grid__cell${filled ? ' auth-grid__cell--filled' : ''}`}
            style={{ '--cell-delay': `${index * 18}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
/* END_METHOD_LoginPlanningGrid */
